module.exports = __webpack_public_path__ + "static/media/logo1.83540438.svg";